import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getDashOrderStatusListByUserid, getOrderStatusListbyAfid,setofUpdatedashboardOrderTV
} from 'actions'
import {isEmpty} from 'lodash'
import {Grid} from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
  const { OrderStatusList,updatedashboardOrderTY} = accountsData;
    const { OrderStatusAntalList,DashboardOrderFilterOption} = DashBoard;
    return {
        authUser,OrderStatusAntalList,OrderStatusList,DashboardOrderFilterOption,updatedashboardOrderTY
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getDashOrderStatusListByUserid: (Afid,userid,FilterOption) => dispatch(getDashOrderStatusListByUserid(Afid,userid,FilterOption)),
        getOrderStatusListbyAfid: (Afid,isFrom) => dispatch(getOrderStatusListbyAfid(Afid,isFrom)),
        setofUpdatedashboardOrderTV: () => dispatch(setofUpdatedashboardOrderTV()),
        dispatch
    };
}

class OrderTable extends Component {
    state={
        OrderStatusAntalList:[],
        DashboardOrderFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
      }
      intervalID = null
      componentDidMount=()=>{
        
        const Afid = this.props.Afid;
        //if(isEmpty(this.props.OrderStatusList)){
            this.props.getOrderStatusListbyAfid(Afid,0)
        //}
        this.props.getDashOrderStatusListByUserid(Afid,undefined,this.state.DashboardOrderFilterOption)
        .then(() => {
          this.initiateInterval() 
          this.setState({done: true})   
      })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
          () => {
            if(this.state.done === true){            
              this.setState({done: false})   
            const Afid = this.props.Afid;
            this.props.getDashOrderStatusListByUserid(Afid,undefined,this.state.DashboardOrderFilterOption)
            .then(() => {
              this.initiateInterval() 
              this.setState({done: true})   
          })
        }
          },
          180000
      );
       
      }
      componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
      }
      componentDidUpdate=()=>{
        const Afid = this.props.Afid
        if(parseInt(this.props.updatedashboardOrderTY) === 1){
          this.props.getDashOrderStatusListByUserid(Afid,undefined,this.state.DashboardOrderFilterOption)
          .then(() => {
            this.initiateInterval() 
            this.setState({done: true})   
        })
          this.props.setofUpdatedashboardOrderTV()
      }
       /*
        if(this.props.DashboardOrderFilterOption !== this.state.DashboardOrderFilterOption)
        {
          if(!isEmpty(this.props.DashboardOrderFilterOption)){
            let FAfid = !isEmpty(this.props.DashboardOrderFilterOption.filter(item=>{ return item.Meta === 'Konton'}))?
            this.props.DashboardOrderFilterOption.filter(item=>{ return item.Meta === 'Konton'})[0].Value:
            this.props.Afid;
            if(FAfid !==  this.props.Afid){
              this.props.getOrderStatusListbyAfid(FAfid,0)
            }
          }
             
            const Afid = this.props.Afid;
            this.props.getDashOrderStatusListByUserid(Afid) 
            .then(() => {
              this.initiateInterval() 
              this.setState({done: true})   
          })
            this.setState({
              DashboardOrderFilterOption:this.props.DashboardOrderFilterOption 
            }) 
        }
        */
    }
      getStalus=(status,Afid)=>{
        if(isEmpty(this.props.OrderStatusList)){
          if (status === 2) return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 20, fontWeight: '600', color: '#13E0EB' }}><IntlMessages id="Order.status.new"/></p></div>
          if (status === 3) return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 20, fontWeight: '600', color: '#FFC895' }}><IntlMessages id="Order.status.processed"/></p></div>
          if (status === 4) return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 20, fontWeight: '600', color: '#be4d25' }}><IntlMessages id="Order.status.supplemented"/></p></div>
          if (status === 5) return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 20, fontWeight: '600', color: '#93F8B3' }}><IntlMessages id="Order.status.Done"/></p></div>
        // if (status === 2) return <div style={{ height: '100%',minWidth:"150px", border: '1px solid transparent', borderRadius: '2px' }} className="bg-info text-white d-flex align-items-center my-2 justify-content-center"><p style={{ margin: '2px 10px', fontSize: 20 }}><IntlMessages id="Order.status.new"/></p></div>
        // if (status === 3) return <div style={{ height: '100%',minWidth:"150px", border: '1px solid transparent', borderRadius: '2px' }} className="bg-warning text-white d-flex align-items-center my-2 justify-content-center"><p style={{ margin: '2px 10px', fontSize: 20 }}><IntlMessages id="Order.status.processed"/></p></div>
        // if (status === 4) return <div style={{ height: '100%',minWidth:"150px", border: '1px solid transparent', borderRadius: '2px' }} className="bg-warning text-white d-flex align-items-center my-2 justify-content-center"><p style={{ margin: '2px 10px', fontSize: 20 }}><IntlMessages id="Order.status.supplemented"/></p></div>
        // if (status === 5) return <div style={{ height: '100%',minWidth:"150px", border: '1px solid transparent', borderRadius: '2px' }} className="bg-success text-white d-flex align-items-center my-2 justify-content-center"><p style={{ margin: '2px 10px', fontSize: 20 }}><IntlMessages id="Order.status.Done"/></p></div>
      }
      else{        
        let Sttsta=this.props.OrderStatusList.filter(item=>{
          // console.log("?????????????????????????????????")
          // console.log( parseInt(item.Value))
          // console.log( parseInt(status))
          // console.log( parseInt(item.Value) === parseInt(status))
          // console.log( item.Meta !=="HO.KLAR")
          // console.log( item.Meta !=="HC.KLAR" )
          // console.log( parseInt(item.Afid) )
          // console.log( parseInt(Afid) )
          // console.log( (parseInt(item.Afid) === parseInt(Afid)) )
          // console.log( (parseInt(item.id) === 0) )
          // console.log( (parseInt(item.Afid) === parseInt(Afid) || parseInt(item.id) === 0) )
          // console.log("?????????????????????????????????")
          return parseInt(item.Value) === parseInt(status) && item.Meta !=="HO.KLAR" && item.Meta !=="HC.KLAR" && (parseInt(item.Afid) === parseInt(Afid) || parseInt(item.id) === 0)
        }) 
        return (
          // <div style={{ height: '100%',minWidth:"150px", border: '1px solid transparent', borderRadius: '2px',backgroundColor:isEmpty(Sttsta)?'#e6e6e6':Sttsta[0].Color  }} 
          // className=" text-white d-flex align-items-center my-2 justify-content-center">
          //   <p style={{ margin: '2px 10px', fontSize: 20 }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
          <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 text-white">
            <div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor:isEmpty(Sttsta)?'#e6e6e6':Sttsta[0].Color, marginRight: '15px' }}></div>
            <p style={{ fontSize: this.props.psFontSize2 > 1 ? this.props.psFontSize2 : 20, fontWeight: '600', textAlign: 'left' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p>
          </div>


        )
        // if (Sttsta[0].Meta === "Utkast") return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 20, fontWeight: '600', color: '#FFFF85' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // if (Sttsta[0].Meta === "Ny") return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 20, fontWeight: '600', color: '#7793F5' }}><IntlMessages id="Order.status.new"/></p></div>
        // if (Sttsta[0].Meta === 'Fakturerbar') return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 20, fontWeight: '600', color: '#C377E0' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // if (Sttsta[0].Meta === 'Behandlas') return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 20, fontWeight: '600', color: '#FFC895' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // if (Sttsta[0].Meta === 'Kompletteras') return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 20, fontWeight: '600', color: '#FFC895' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // if (Sttsta[0].Meta === 'KLAR') return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 20, fontWeight: '600', color: '#93F8B3' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
      }
      }
    render() {
      // console.log('test5655', this.props.OrderStatusList )
        return (
            <div style={{width:'95%',overflowY: "auto",height: this.props.heightValue > 1 ?  this.props.heightValue : 300}}>
               
                 {
                  this.state.done === false?  
                  <>
                  <div className="row mx-1">
                      <div className="col-12 row mx-1">
                          <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                      </div>
                      <div className="col-12 row mx-1">
                          <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                      </div>
                      <div className="col-12 row mx-1">
                          <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                      </div>
                  </div>
                  </>
                  :
                 !isEmpty(this.props.OrderStatusAntalList)?this.props.OrderStatusAntalList.map((n,index) => {
                    return (
                        <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        style={{justifyContent: "space-between"}}
                        > 
                        <Grid item >{this.getStalus(n.Status,n.Afid)}</Grid>
                        <Grid item ><span style={{fontSize:35, fontWeight: '400'}}>{n.Antal}</span>st</Grid>
                        </Grid>
                    )
                 })
                 :""}   
               
                    
               
            </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(OrderTable);